import { type RouteRecordRaw } from 'vue-router'
import './route-types'

export function createMailRoutes(startPath: string) {
  return [
    {
      path: startPath,
      component: () => import('./components/layouts/MailLayout.vue'),
      // The layout renders its own section sidebar; the app shell rails
      // the main sidebar for the whole section, including compose (which
      // hides the section sidebar but stays railed).
      meta: { railMainSidebar: true },
      redirect: () => ({ name: 'mail-inbox' }),
      children: [
        {
          path: 'inbox',
          component: () => import('./components/layouts/MailInboxLayout.vue'),
          children: [
            {
              path: '',
              name: 'mail-inbox',
              component: () => import('./views/MailInboxView.vue')
            },
            {
              path: ':id',
              component: () =>
                import('./components/layouts/MailMessageLayout.vue'),
              props: true,
              children: [
                {
                  path: '',
                  name: 'mail-message',
                  component: () => import('./views/MailMessageView.vue'),
                  props: true
                }
              ]
            }
          ]
        },
        {
          path: 'compose',
          name: 'mail-compose',
          component: () => import('./views/MailComposeView.vue')
        }
      ]
    }
  ] as readonly RouteRecordRaw[]
}
